import React from 'react';
import Icon from '../../../components/AppIcon';

const OperationalMetricsCard = ({ title, value, unit, change, changeType, icon, threshold, status }) => {
  const getStatusColor = () => {
    if (status === 'critical') return 'bg-error/10 border-error';
    if (status === 'warning') return 'bg-warning/10 border-warning';
    return 'bg-success/10 border-success';
  };

  const getStatusIcon = () => {
    if (status === 'critical') return 'AlertTriangle';
    if (status === 'warning') return 'AlertCircle';
    return 'CheckCircle';
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className={`card ${getStatusColor()} transition-smooth`}>
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name={icon} size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
            <div className="flex items-baseline gap-2 mt-1">
              <span className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground">{value}</span>
              {unit && <span className="text-sm text-muted-foreground">{unit}</span>}
            </div>
          </div>
        </div>
        <Icon name={getStatusIcon()} size={20} color={status === 'critical' ? 'var(--color-error)' : status === 'warning' ? 'var(--color-warning)' : 'var(--color-success)'} />
      </div>
      
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon 
            name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
            size={16} 
            className={getChangeColor()}
          />
          <span className={`text-sm font-medium ${getChangeColor()}`}>{change}</span>
          <span className="text-xs text-muted-foreground">vs last period</span>
        </div>
        {threshold && (
          <span className="text-xs text-muted-foreground">Target: {threshold}</span>
        )}
      </div>
    </div>
  );
};

export default OperationalMetricsCard;